import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

/**
 * PageBreadcrumb
 * A reusable breadcrumb bar styled to match the existing ProgrammePageShell breadcrumb.
 * Renders a dark maroon hero strip with "Home > [parent] > [current]" navigation.
 *
 * Props:
 *  - crumbs: Array of { label, to } — intermediate breadcrumbs (optional, between Home and current)
 *  - current: string — the current page label (rendered bold / white, not a link)
 */
const PageBreadcrumb = ({ crumbs = [], current }) => {
  return (
    <div
      className="w-full pt-20"
      style={{ background: 'linear-gradient(135deg, #1e293b 0%, #800000 60%, #450000 100%)' }}
    >
      {/* Decorative blobs */}
      <div
        aria-hidden
        className="pointer-events-none absolute top-0 right-0 w-80 h-80 bg-white/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"
      />
      <nav
        className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-5 flex items-center gap-2 text-sm flex-wrap"
        aria-label="Breadcrumb"
      >
        <Link
          to="/"
          className="text-white/60 hover:text-white transition-colors duration-200 font-medium"
        >
          Home
        </Link>

        {crumbs.map((crumb, i) => (
          <React.Fragment key={i}>
            <ChevronRight className="w-4 h-4 text-white/40 flex-shrink-0" />
            {crumb.to ? (
              <Link
                to={crumb.to}
                className="text-white/60 hover:text-white transition-colors duration-200 font-medium"
              >
                {crumb.label}
              </Link>
            ) : (
              <span className="text-white/60 font-medium">{crumb.label}</span>
            )}
          </React.Fragment>
        ))}

        <ChevronRight className="w-4 h-4 text-white/40 flex-shrink-0" />
        <span className="text-white font-bold">{current}</span>
      </nav>
    </div>
  );
};

export default PageBreadcrumb;
